/// <amd-module name="Wit/Settings/BoardsExternalIntegration/constants/Constants" />
export namespace GitHubConnectionConstants {
    export const OAuthScheme = "OAuth";
    export const GitHubAppScheme = "InstallationToken";
    export const EnterpriseCredentialsScheme = "UsernamePassword";
    export const EnterpriseOAuthScheme = "OAuth2";
    export const PersonalAccessTokenScheme = "PersonalAccessToken";
    export const EnterprisePersonalAccessTokenScheme = "Token";
    export const GitHubBoardsServiceEndpointType = "githubboards";
    export const GitHubServiceEndpointType = "github";
    export const EnterpriseServiceEndpointType = "githubenterpriseboards";
    export const GitHubEnterpriseEndpointType = "githubenterprise";
    export const ServiceProviderUrl = "http://github.com";
    export const PatScopes = "repo, admin:repo_hook, read:user, user:email";
    export const PersonalAccessTokenLink = "https://go.microsoft.com/fwlink/?linkid=2051996";
    export const FabrikamUrl = "https://github.fabrikam.com";
    export const GitHubDoesNotSupportIELearnMoreUrl = "https://go.microsoft.com/fwlink/?linkid=2053726";
    export const GHEOAuthInstructionUrl = "https://go.microsoft.com/fwlink/?linkid=2095009";
    // List of query parameters that are part of the oauth callback url. To keep the url clean, we need to remove it.
    export const QueryParametersToRemove: string[] = [
        "avatarurl",
        "key",
        "githubhandle",
        "serviceendpointid",
        "strongboxkey",
        "oauthconfigurationid",
        "entryPoint",
        "orgNodeId",
        "existingConnectionId",
        "preCreate",
        "errorCode",
        "isGHE",
        "installation_id",
        "acquisitionId",
        "goToKanbanBoard",
        "code",
        "state",
        "setup_action"
    ];
    export const UseWellKnownStrongBoxLocationKey = "useWellKnownStrongBoxLocation";
    export const ExistingConnectionId = "existingConnectionId";
    export const GitHubProviderKey = "github.com";
    export const FirstRunExperienceClosedSettingKey = "witGitHubApp/firstRunExpClosed";
    export const AzureDevOpsSupportPageUrl = "https://go.microsoft.com/fwlink/?linkid=328778";
    export const RepositoryDataProviderId = "ms.vss-work-web.github-repositories-data-provider";
    export const GitHubPreCreateDataProviderId = "ms.vss-work-web.github-precreate-repositories-data-provider";
    export const GitHubConfigurationSettingsDataProviderId = "ms.vss-work-web.github-configuration-settings-data-provider";
    export const GitHubOrgListDataProviderId = "ms.vss-work-web.github-org-list-data-provider";
    export const GitHubPostInstallDataProviderId = "ms.vss-work-web.github-app-post-install-data-provider";
    export const RestApiRepoId = "RestApiId";
    export const OAuthScope = "repo,read:user,user:email";
    export const EnableOnPremToGitHubDotComPATConnectionFeature = "WebAccess.WorkItemTracking.EnableOnPremToGitHubDotComPATConnection";
}

export namespace DocUrls {
    export const KanbanBoard_QuickStart = "https://aka.ms/azureboards/kanban-quickstart";
    export const GitHubAndAzureBoards_LinkPullRequest = "https://aka.ms/azureboardsgithub-link";
    export const GitHubAndAzureBoards_BoardBadge = "https://aka.ms/azureboardsgithub-badge";
    export const GitHubAndAzureBoards_Portal = "https://aka.ms/azureboardsgithub";
}
